import { useLocation, Link } from "react-router-dom";
import emitter from "../../services/emitter-service";
import { useSelector } from "react-redux";
import { SideBar } from "../sidebar";
import logo from "../../assets/images/logo.png";
import { useState } from "react";

export const Navbar = ({ open, setOpen, token }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const { userInfo } = useSelector((store) => store.login);

  return (
    <>
      <nav className="border-gray-200 z-40 fixed top-0 left-0 right-0 bg-gray-100 h-16">
        <div className="flex flex-wrap items-center justify-between mx-auto p-4">
          {/* Left side */}
          <div className="flex justify-start items-center gap-x-5">
            {!location.pathname.includes("/signin") && (
              <button
                type="button"
                onClick={() => setOpen(!open)}
                className="inline-flex items-center p-2 text-sm ring-2 ring-gray-300 text-gray-500 rounded-lg hover:bg-gray-100 focus:outline-none focus:bg-gray-200 focus:ring-2 focus:ring-gray-300"
              >
                {!open ? (
                  <svg
                    className="w-4 h-4"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      clipRule="evenodd"
                      fillRule="evenodd"
                      d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
                    ></path>
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="w-4 h-4"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6 18 18 6M6 6l12 12"
                    />
                  </svg>
                )}
              </button>
            )}
            <Link to={'/dashboard'} className="flex-shrink-0">
              <img
                src={logo}
                className="h-8"
                alt="Pl Logo"
              />
            </Link>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden inline-flex items-center p-2 text-gray-500 rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
          >
            <span className="sr-only">Open main menu</span>
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {mobileMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>

          {/* Navigation items */}
          <div className={`${mobileMenuOpen ? 'block lg:bg-transparent bg-white lg:shadow-none shadow-lg' : 'hidden'} w-full lg:block lg:w-auto`}>
            <ul className="flex flex-col lg:flex-row lg:items-center lg:space-x-8 mt-4 lg:mt-0">
              {!location.pathname.includes("/signin") && (
                <li className="py-2 lg:py-0">
                  <div className="text-orange-500 px-3 lg:px-0">
                    <span className="block lg:inline">{`Welcome ${userInfo?.firstname} ${userInfo?.lastname}!`}</span>
                    <span className="text-green-600 text-sm block lg:inline lg:ml-2">
                      ({userInfo?.ability === "Super-Admin" ? "Super Admin" : "Admin"})
                    </span>
                  </div>
                </li>
              )}

              {!location.pathname.includes("/signin") && (
                <li className="py-2 lg:py-0">
                  <Link
                    to="/policy"
                    className={`block px-3 lg:px-0 ${location.pathname.includes("/policy")
                      ? "text-blue-700"
                      : "text-gray-900 hover:text-blue-700"
                      }`}
                  >
                    Terms & Conditions
                  </Link>
                </li>
              )}

              <li className="py-2 lg:py-0">
                <button
                  onClick={() =>
                    location.pathname !== "/signin"
                      ? emitter.emit("SignOutPopUp")
                      : null
                  }
                  className="block w-full text-left px-3 lg:px-0 text-gray-900 hover:text-red-500"
                >
                  {location.pathname.includes("/signin") ? "" : "Log out"}
                </button>
              </li>
            </ul>
          </div>

          {/* Profile photo */}
          {!location.pathname.includes("/signin") && (
            <div className="hidden lg:flex items-center ml-4">
              <img
                src={userInfo?.profile_photo}
                className="h-8 w-8 lg:h-10 lg:w-10 rounded-full"
                alt="Profile"
              />
            </div>
          )}
        </div>
      </nav>
       {(open && token) && (
        <div
          className="fixed inset-0 z-30 bg-black bg-opacity-40"
          onClick={() => setOpen(false)}
        ></div>
      )}
      <SideBar open={open} token={token} />
    </>
  );
};
